// import request from '@/utils/request'
const api = 'api';

//  登录
export function getLoginApi(query) {
    return request({
        url: api + '/user/login',
        method: 'post',
        data: query
    })
}

//  忘记密码 tianyue.com/api/user/resetpwd
export function getResetpwdApi(query) {
    return request({
        url: api + '/user/resetpwd',
        method: 'post',
        data: query
    })
}

//修改头像用户名   tianyue.com/api/person_center/profile
export function setProfileApi(query) {
    return request({
        url: api + '/person_center/profile',
        method: 'post',
        data: query
    })
}